import NationalRatingWidget from './component'

export default NationalRatingWidget
